import React from 'react';

import staticURL from 'lib/staticURL';
import {isGlyphIcon, ToolIconSource} from 'llm/chat-library/tool-details/types';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface ToolIconDisplayProps {
  icon: ToolIconSource;
  glyphClassName?: string;
  imgClassName?: string;
}

export function ToolIconDisplay({icon, glyphClassName, imgClassName}: ToolIconDisplayProps): JSX.Element {
  if (isGlyphIcon(icon)) {
    return <BenchlingIcon icon={icon.iconName} className={glyphClassName} />;
  }
  return <img src={staticURL(icon.iconUrl)} alt={`${icon.serverName} icon`} className={imgClassName} />;
}
